import { format, startOfMonth, endOfMonth, subMonths, subDays } from 'date-fns';

/** Filtro de período compartilhado entre Usuários > Dashboard e a página do usuário, pra os números
 *  baterem nas duas telas. Datas em YYYY-MM-DD, o mesmo formato que o backend lê em `de`/`ate`. */
export type PeriodoPreset = 'tudo' | '7d' | '30d' | 'mes' | 'mes_passado';

export const PERIODO_PRESETS: { key: PeriodoPreset; label: string }[] = [
  { key: 'tudo', label: 'Todo o período' },
  { key: '7d', label: 'Últimos 7 dias' },
  { key: '30d', label: 'Últimos 30 dias' },
  { key: 'mes', label: 'Este mês' },
  { key: 'mes_passado', label: 'Mês passado' },
];

export interface Periodo {
  de?: string;
  ate?: string;
}

const ymd = (d: Date) => format(d, 'yyyy-MM-dd');

export function periodoDoPreset(preset: PeriodoPreset, hoje = new Date()): Periodo {
  switch (preset) {
    case '7d':
      return { de: ymd(subDays(hoje, 6)), ate: ymd(hoje) };
    case '30d':
      return { de: ymd(subDays(hoje, 29)), ate: ymd(hoje) };
    case 'mes':
      return { de: ymd(startOfMonth(hoje)), ate: ymd(hoje) };
    case 'mes_passado': {
      const mesPassado = subMonths(hoje, 1);
      return { de: ymd(startOfMonth(mesPassado)), ate: ymd(endOfMonth(mesPassado)) };
    }
    default:
      return {};
  }
}

export function isPeriodoPreset(v: string | null): v is PeriodoPreset {
  return PERIODO_PRESETS.some((p) => p.key === v);
}

/** Período imediatamente anterior, do mesmo tamanho (pra comparação ↑↓). Sem período, não há. */
export function periodoAnterior(p: Periodo): Periodo | null {
  if (!p.de || !p.ate) return null;
  const dia = 24 * 60 * 60 * 1000;
  const de = new Date(`${p.de}T12:00:00Z`).getTime();
  const ate = new Date(`${p.ate}T12:00:00Z`).getTime();
  const tamanho = Math.round((ate - de) / dia) + 1;
  const ymdUtc = (t: number) => new Date(t).toISOString().slice(0, 10);
  return { de: ymdUtc(de - tamanho * dia), ate: ymdUtc(de - dia) };
}
